const BFF = import.meta.env.VITE_BFF_BASE;
const CONSUS_ID = import.meta.env.VITE_CONSUS_ID;

function bust() {
  return `_ts=${Date.now()}`;
}

export async function fetchAgilePrices(params = "limit=100") {
  const qs = params ? `${params}&${bust()}` : bust();
  const url = `${BFF}/api/agile?${qs}`;
  console.info("[api] GET", url);
  const r = await fetch(url, { headers: { Accept: "application/json" }, cache: "no-store" });
  console.info("[api] /api/agile status", r.status);
  if (!r.ok) throw new Error(`Agile ${r.status}`);
  const data = await r.json();
  console.info("[api] /api/agile rows", Array.isArray(data) ? data.length : "n/a");
  return data;
}

export async function fetchBatteryOperations(params: {
  start_time?: string;
  end_time?: string;
  limit?: number;
  consus_id?: string;
} = {}) {
  const search = new URLSearchParams();
  const cid = params.consus_id ?? CONSUS_ID;
  if (cid) search.set("consus_id", cid);
  if (params.start_time) search.set("start_time", params.start_time);
  if (params.end_time) search.set("end_time", params.end_time);
  if (params.limit != null) search.set("limit", String(params.limit));
  search.set("_ts", String(Date.now()));

  const url = `${BFF}/api/operations?${search.toString()}`;
  console.info("[api] GET", url);
  const r = await fetch(url, { headers: { Accept: "application/json" }, cache: "no-store" });
  console.info("[api] /api/operations status", r.status);
  if (!r.ok) throw new Error(`Ops ${r.status}`);
  const data = await r.json();
  console.info("[api] /api/operations rows", Array.isArray(data) ? data.length : "n/a");
  return data;
}

// ---------- Types ----------
export interface AgilePrice {
  id: number;
  region_code: string;
  product_code: string;
  tariff_code: string;
  timestamp_start: string;
  timestamp_end: string;
  import_price_p_per_kwh: number | null;
  export_price_p_per_kwh: number | null;
  source: string;
  created_at: string;
  updated_at: string;
}

export interface ModbusBlob {
  id: string;
  consus_id: string;
  source_type: string;
  timestamp: string; // UTC from backend
  mode: string | null;
  data: Record<string, any> | null;
}

export interface BatteryOperation {
  id: number | string;
  consus_id: string;
  timestamp: string;            // shifted to local alignment (see hook)
  state_of_charge: number | null;
  battery_power_output: number | null; // kW
  grid_power: number | null;           // kW (sign follows meter: NEGATIVE=IMPORT)
  load_power: number | null;           // kW
  voltage: number | null;
  current: number | null;
  mode: string | null;
  source_type: string;
  registers: Record<string, any> | null;
}
